module.exports = function(app) {
	'use strict'
	app.directive('checkedListItemDir',checkedListItemDir);
	checkedListItemDir.$inject=['$timeout','refreshtokenService','alertService','serverError','config','postDataService','getDataService','jQuery'];
	function checkedListItemDir($timeout, refreshtokenService, alertService,serverError, config, postDataService, getDataService, jQuery) {
		return {
			restrict: 'E',
			scope:{
				parent:'=',
				type:'=',
				list:'=',
				multiUpdate:'='
			},
			replace:true,
			template: require('./partial/checkedListItem.html'),
			link: function(scope, ele, $attrs, ctrl) {
				scope.itemChecked = {item: {}};
				function scrollElement() {
					$timeout(function() {
						var checkedItem = jQuery(".checkedEditPost"+ scope.type);
						if(checkedItem.length != 0) {
							var topPos = checkedItem[0].offsetTop;
							jQuery('#'+ scope.type + 'scroll').animate({scrollTop: topPos-2},600);
						}
						scope.scrollElement = true;
					},300)
				}
				scope.$watch(function(){
					return scope.list
				  }, function(newValue, oldValue){
					if (newValue && newValue !== oldValue) {
						// race condition
						if(scope.parent[scope.type + 'OnLoad']) {
							scrollElement()
						}
					}
					
				},true);
				scope.$watch(function(){
					return scope.parent[scope.type + 'OnLoad']
				  }, function(newValue, oldValue){
					if (newValue && newValue !== oldValue) {
						if(scope.multiUpdate) {
							for (var i =0; i<newValue.length;i++) {
								scope.itemChecked.item[newValue[i]] = true;
							}
						} else {
							scope.itemChecked.item[newValue] = true;
						}
						// race condition
						if(scope.list && scope.list.length>0) {
							scrollElement()
						}
					}
					
				},true);
				scope.updateSelection = function(id, checked) {
					if(checked) {
						if(scope.multiUpdate) {
							scope.parent[scope.type].push(id)
						} else {
							for (var i=0; i<scope.list.length; i++){
								if (scope.list[i]._id !== id) {
									scope.itemChecked.item[scope.list[i]._id] = false;
								}
							}
							scope.parent[scope.type] = id;
						}
					} else {
						if(scope.multiUpdate) {
							scope.parent[scope.type].splice(scope.parent[scope.type].indexOf(id),1)
						} else {
							scope.parent[scope.type] = null;
						}
					}
				}
			}
		}
	}
}


//////////////////
// WEBPACK FOOTER
// ./public/development/assets/app/js/directive/checkedListItem/checkedListItemDirective.js
// module id = 437
// module chunks = 0